export const environment = {
  production: false,
  // qlickcloud_domain: 'test-qlick.cloud',
  // myqlickcloud_domain: 'test-qlick.cloud',
  api_server: 'https://api.test-qlick.cloud',
  stripe_publishable_key:
    'pk_test_51HiNsPBxSL8GpXNC3Zfojbj0bVwysfPoNxffhmIydYikgmUcwfZW2w6YLN59mijyVzh93aB1dZ3kjY7WgN16Qbkn001oGHnWJk',
  oidcAuthority: 'https://auth.test-qlick.cloud',
  oidcClientId: '364501396977943386',
  oidcRedirectUrl: 'https://test-qlick.cloud/auth/callback',
  oidcPostLogoutRedirectUrl: 'https://test-qlick.cloud',
};
